<template>
   <div class="container mt-5 mb-5">
          <iframe
            src="https://static.zdassets.com/web_widget/latest/liveChat.html?v=10#key=mmkgroup.zendesk.com"
            width="90%"
            height="600px"
            frameborder="0" >
           </iframe>
    </div>
</template>

<script id="ze-snippet" src="https://static.zdassets.com/ekr/snippet.js?key=c9367b31-7b36-43bb-a8fb-7b1fd90a94bd"> 
</script>


<script>
export default {
    name:"chat",
}
</script>

<style>

</style>